import React from 'react'
import write from "../../assets/DropdwonIcons/jamwrite.svg"


const JobDescriptionHeader = ({ title }) => {
	return (
		<div className='AddJob_main_container_header'>
			<div className="AddJob_main_header_icon">
				<img src={write} alt="hero" style={{ width: 30, height: 30 }} />
			</div>
			<div className="AddJob_main_header_text">
				<h3 className="AddJob_main_text">
					{title}
				</h3>
			</div>
		</div>
	)
}

export default JobDescriptionHeader
